import Cookies from 'js-cookie';

const getFrontendUserToken = () => {
  const raw = Cookies.get('frontend_user_token');
  if (!raw) return null;
  try {
    return JSON.parse(atob(raw));
  } catch {
    return null;
  }
};
export const FrontendUserCookieService = {
  getUserId: () => getFrontendUserToken()?.userId ?? null,
  getAccountId: () => getFrontendUserToken()?.accountId ?? 0,
  getLegacyUserId: () => getFrontendUserToken()?.legacyUserId ?? 0,
  getExp: () => getFrontendUserToken()?.exp ?? null,
};
